module.exports = __webpack_public_path__ + "assets/fonts/alarm-bell.86932b97.svg";